import { useQueryParam } from '@hooks/useQueryParams';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { IPaymentQrCode } from '../models';

export function useGetPaymentDelay() {
  const { params } = useQueryParam();
  const url = `/v1/contract/payment/qr/`;

  return useQuery<IPaymentQrCode>({
    queryKey: ['payment-qr-code', params.token],
    queryFn: async () => {
      const res = await $api.get(url + params.token);

      return res?.data?.data;
    }
  });
}
